import React, { useEffect } from "react";
import {
  Button,
  CircularProgress,
  Grid,
  Hidden,
  IconButton,
  makeStyles,
  Menu,
  MenuItem
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import { useQuery, gql } from "@apollo/client";
import { AccountCircle } from "@material-ui/icons";

const useStyles = makeStyles(x => ({
  [x.breakpoints.down("lg")]: {
    user: {
      position: "absolute",
      top: "10px",
      right: "20px"
    }
  },
  [x.breakpoints.up("lg")]: {
    user: {
      position: "absolute",
      right: "-80px",
      top: "10px"
    }
  }
}));
export default function NavbarToggle() {
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const GETUSER = gql`
    query getUser {
      me {
        username
      }
    }
  `;
  const { loading, error, data } = useQuery(GETUSER);

  useEffect(() => {
    if (error) {
      history.replace("/");
    }
  }, [error]);
  return (
    <nav className="nav">
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      {/* <a href="#" onClick={this.handleClick} className="nav-link nav-link-icon toggle-sidebar d-sm-inline d-md-inline d-lg-none text-center">
          <i className="material-icons">&#xE5D2;</i>
        </a> */}
      <Grid container justifyContent="space-between">
        <Hidden smUp>
          <Grid item>
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
              PaperProps={
                {
                  // style: {
                  //   maxHeight: ITEM_HEIGHT * 4.5,
                  //   width: '20ch',
                  // },
                }
              }
            >
              <MenuItem
                onClick={() => {
                  history.push("/meetingNotes");
                  handleClose();
                }}
              >
                Meeting notes
              </MenuItem>

              <MenuItem
                onClick={() => {
                  localStorage.removeItem("token");
                  history.replace("/");
                  handleClose();
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </Grid>{" "}
        </Hidden>
        <Hidden smDown>
          <Grid
            item
            container
            alignItems="center"
            style={{
              marginTop: "10px"
            }}
          >
            <Grid container justifyContent="flex-end" className={classes.user}>
              {loading && <CircularProgress />}
              {!loading && data && (
                <>
                  {" "}
                  <Button
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    // color="primary"
                    // variant="outlined"
                    style={{
                      backgroundColor: "#fff",
                      color: "#291514"
                    }}
                  >
                    <AccountCircle
                      style={{ marginRight: "5px", fontSize: "15" }}
                    />{" "}
                    {data.me.username}
                  </Button>
                  <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                      style: {
                        // maxHeight: ITEM_HEIGHT * 4.5,
                        // width: '20ch',
                        marginTop: "30px"
                      }
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        localStorage.removeItem("token");
                        history.replace("/");
                        handleClose();
                      }}
                    >
                      Logout
                    </MenuItem>
                  </Menu>
                </>
              )}
            </Grid>
          </Grid>
        </Hidden>
      </Grid>
    </nav>
  );
}
